import { V1_SET_CONTEXT_MENU } from '../actions/contextMenu/v1setContextMenu'

const initialState = {
  context: '',
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_SET_CONTEXT_MENU:
      return { ...state, context: action.context }
    default:
      return state
  }
}
